import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Rocket, Clock, Wrench } from "lucide-react";
import { useNavigate } from "react-router-dom";

const benefits = [
  { icon: Clock, text: "6-8 weeks" },
  { icon: Wrench, text: "Your, real bank excels + purchase pdfs" },
  { icon: Rocket, text: "We handle mechanics; You test your docs & edge cases" },
];

const DesignPartner = () => {
  const navigate = useNavigate();

  const handleJoinWaitlist = () => {
    navigate('/join-waitlist');
  };

  return (
    <section className="section-padding bg-genie-gradient">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-foreground/20 text-primary-foreground text-sm font-medium mb-6">
            <Rocket className="w-4 h-4" />
            Limited design‑partner slots open
          </span>

          <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary-foreground mb-8">
            Shape the future of Tally Automation
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-10">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-center gap-2 text-primary-foreground/90"
              >
                <benefit.icon className="w-5 h-5" />
                <span className="text-sm font-medium">{benefit.text}</span>
              </motion.div>
            ))}
          </div>

          <Button
            size="lg"
            variant="secondary"
            className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 px-8 py-6 text-base font-semibold"
            onClick={handleJoinWaitlist}
          >
            Apply as a Design Partner
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default DesignPartner;
